<template>
    <div v-if="stateKeycard" class="wrapper" :class="{disabled:isSelected}" @click="selectOption(index,stateKeycard.number)">
        <div class="header">
            <inline-svg v-if="isactive" class="icon" src="/img/icons/icon-radio-active.svg" />
            <img v-else class="icon" src="/img/icons/icon-radio.svg">
            <p class="title">{{ stateKeycard.number}}</p>
        </div>
        <div class="buttons">
            <button @click.stop="remove">{{ $t('participants.keycard.delete') }}</button>
        </div>
    </div>
</template>

<script>
    import { apiClient } from "@/api";

    export default {
        props: {
            keycard:Object,
            index:Number,
            isactive:Boolean
        },
        data() {
            return {
                stateKeycard: this.keycard
            }
        },
        methods: {
            selectOption(selected,value){
                if(!this.isSelected){
                    this.$emit('optionSelected',{selected,value})
                }    
            },
            edit(){
                //TODO TÉ SENTIT D'EDITAR UN ALIAS, PERÒ ARA NO HI HA LA OPCIÓ DE ALIAS
            },
            async remove(){
                if(confirm("Do you really want to delete?")){
                    await apiClient.deleteKeyCard(this.stateKeycard.id);
                    const number = this.stateKeycard.number;
                    this.$store.commit('customer/REMOVE_KEYCARD',{number});
                    this.stateKeycard = null;
                }
            }
        },
        computed: {
            isSelected(){return this.stateKeycard && this.stateKeycard.selected !== undefined}
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{ 
        @apply border-1 border-grey-border p-4 mb-3;
    }

    .header{
        @apply flex justify-between;
    }

    .icon {
        @apply w-6 h-6 object-contain flex-grow-0 mr-2;
    }

    .title {
        @apply text-sm text-black text-left font-bold flex-grow;
    }

    .disabled .title {
        @apply text-grey-text;
    }

    .buttons {
        margin: 10px 32px;

        button {
            @apply text-red;
        }
        .separator {
            @apply text-grey-separator mx-3 text-xl;
            vertical-align: middle;
        }
    }
</style>